import { http } from '@/utils/http';

const BASEURL =
  '/vote/2020project/2020chongqing_beautiful_one/controller.php?enews=';

export const getBaseInfo = () => {
  return http.get(`${BASEURL}base-info`);
};

export const getRules = () => {
  return http.get(`${BASEURL}rules`);
};
